import {createSlice, PayloadAction} from '@reduxjs/toolkit';

interface User {
    id: string;
    customerCode: string;
}

interface UserState {
    value: User;
}

const initialState: UserState = {
    value: { id: "", customerCode: ""},
}

export const userSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
        login: (state, action: PayloadAction<User>) => {
            state.value = action.payload
        },
    },
});

export const {login} = userSlice.actions;


export default userSlice.reducer;